import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { spacing, colors } = theme;

export default createUseStyles(
  {
    root: {
      display: 'flex',
      cursor: 'pointer',
      userSelect: 'none',
      alignItems: 'center',
      marginBottom: spacing.sp02,
      color: colors.textPrimary,
    },

    input: {
      display: 'none',
    },

    checked: {
      '& $innerCircle': {
        transform: 'scale(1)',
      },
      '& $radio': {
        borderColor: colors.iconLink,
      },
    },

    disabled: {
      pointerEvents: 'none',
      color: colors.textDisabled,
      '& $innerCircle': {
        backgroundColor: colors.iconDisabled,
      },

      '& $radio': {
        borderColor: colors.iconDisabled,
      },
    },

    radioWrap: {
      height: 20,
      display: 'flex',
      alignItems: 'center',
    },

    innerCircle: {
      width: 10,
      height: 10,
      margin: 0,
      backgroundColor: colors.iconLink,
      borderRadius: '50%',
      transform: 'scale(0)',
      transition: 'all .15s',
    },

    radio: {
      display: 'flex',
      flexShrink: 0,
      flexGrow: 0,
      width: 15,
      height: 15,
      justifyContent: 'center',
      alignItems: 'center',
      border: [1.25, 'solid', colors.iconPrimary],
      borderRadius: '50%',
      transition: 'all .15s',
    },

    label: {
      marginLeft: 9.25,
    },
  },
  {
    name: 'Radio',
  },
);
